import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import { isMobileOnly } from 'react-device-detect';
import {
  BaseBox,
  FlexBox,
  Heading4,
  Heading2,
  DoconModal,
  DoconModalContent,
  DoconModalHeader,
  CenterBox,
  DoconCard,
} from '@docon/docon-ui-library';
import Timings from '../Timings';
import { getAddressString } from 'utils';
import { ClinicIcon } from 'shared/icons';
import { bgColor, borderColor, colors } from 'utilities/colorConfig';

const Modal = styled(DoconModal)`
  width: 90%;
  max-width: 640px;
  max-height: 80%;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  --closeIconColor: ${colors.white};

  ${DoconModalContent} {
    max-height: initial;
    background-color: ${bgColor.base};
  }

  ${DoconModalHeader} {
    font-size: 20px;
    line-height: 24px;
    padding: 16px;
    color: ${colors.white};
    background-color: ${colors.primaryBlue};
  }

  ${DoconCard} {
    padding: 0;
  }

  ${() => isMobileOnly && css`
    max-height: 95%;

    ${DoconModalContent} {
      padding: 0.5rem;
    }
  `}
`;

const Row = styled(FlexBox)`
  padding: 12px 20px;
  gap: 12px 16px;
  
  & + & {
    border-top: 1px solid ${borderColor};
  }
`;

const daysName = ['', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
const days = [1, 2, 3, 4, 5, 6, 7];

function TimingModal({
  isOpen,
  clinic = {},
  onClose,
  ...props
}: any) {

  const [shiftByDay, setShiftByDay] = useState({});
  useEffect(() => {
    const shiftByDay = {};
    clinic.shifts.map((shift: any) => shift.days.map(day => {
      shiftByDay[day] = shiftByDay[day] ? shiftByDay[day] : [];
      shiftByDay[day].push(shift);
    }));
    setShiftByDay(shiftByDay);
  }, [clinic]);

  return (
    <Modal
      hideFooter
      centered
      title={'All timings'}
      isOpen={isOpen}
      onClose={onClose}
      {...props}
    >
      <DoconCard>
        <Row>
          <CenterBox size={45} bg={bgColor.warning} borderRadius={'50%'}>
            <ClinicIcon color={colors.white} width={25} />
          </CenterBox>
          <BaseBox flex={1}>
            <Heading2 title={clinic.name} fontWeight={500} />
            <Heading4 color={colors.secondaryColor} title={getAddressString(clinic.address)} />
          </BaseBox>
        </Row>

        <Row vertical={isMobileOnly} verticalSpace={0}>
          {
            days?.map((day: number) => (
              <BaseBox key={day} flex={'0 0 45%'}>
                <Timings
                  title={daysName[day]}
                  day={day}
                  shifts={shiftByDay[day]}
                />
              </BaseBox>
            ))
          }
        </Row>
      </DoconCard>
    </Modal>
  );
}

export default TimingModal;